import { DocTopic } from '../Common/Constants/Documentation'

export enum ReportTabID {
    REPORT,
    FIELDS,
    FILTER,
    SLAKPI,
    ALARMS,
    SCHEDULING,
    ACDCODES,
    FINANCIAL,
    SETTINGS,
    PRINT,
    ADVANCED,
    DASHBOARD,
    OTHER
}

export const ZOOM_LEVEL_DEFAULT_VALUE = 100

export const TELEPHONY_SYSTEM_TYPE_UNKNOWN = -1 // Unknown.
export const TELEPHONY_SYSTEM_TYPE_VALID_MIN = 0 // Minimum value of range for valid values.
export const TELEPHONY_SYSTEM_TYPE_DUMMY = 0 // Dummy telephone module (does nothing).
export const TELEPHONY_SYSTEM_TYPE_SIMULATOR = 1 // Simulator telephone module.
export const TELEPHONY_SYSTEM_TYPE_BROADSOFT_M6 = 5 // Broadsoft M6 telephone module.
export const TELEPHONY_SYSTEM_TYPE_BROADSOFT_BROADWORKS = 7 // Broadsoft BroadWorks telephone module.
export const TELEPHONY_SYSTEM_TYPE_SYLANTRO_SYNERGY = 10 // Sylantro Synergy telephone module.
export const TELEPHONY_SYSTEM_TYPE_SIEMENS_HIPATH_3000 = 15 // Siemens HiPath 3000 telephone module.
export const TELEPHONY_SYSTEM_TYPE_PANASONIC_TDA_NCP = 20 // Panasonic TDA 30, 50 & 100, and additionally the NCP.
export const TELEPHONY_SYSTEM_TYPE_CISCO_WEBEX_CALLING = 25 // Cisco Webex Calling telephone module.
export const TELEPHONY_SYSTEM_TYPE_MS_TEAMS: number = 30 // MS Teams telephone module.

export const TELEPHONY_SYSTEMS_NOT_SUPPORTING_ACD_CODES: number[] = [
    TELEPHONY_SYSTEM_TYPE_BROADSOFT_M6,
    TELEPHONY_SYSTEM_TYPE_SIEMENS_HIPATH_3000,
    TELEPHONY_SYSTEM_TYPE_PANASONIC_TDA_NCP,
    TELEPHONY_SYSTEM_TYPE_CISCO_WEBEX_CALLING
]

export const getHelpTopicByTab = (tabID: ReportTabID): DocTopic => {
    let topic
    switch (tabID) {
        case ReportTabID.REPORT:
            topic = DocTopic.RPTGRPTPROPSRPTTAB
            break
        case ReportTabID.FIELDS:
            topic = DocTopic.RPTGRPTPROPSFIELDSTAB
            break
        case ReportTabID.FILTER:
            topic = DocTopic.RPTGRPTPROPSFILTERTAB
            break
        case ReportTabID.SLAKPI:
            topic = DocTopic.RPTGRPTPROPSSLAKPITAB
            break
        case ReportTabID.ALARMS:
            topic = DocTopic.RPTGRPTPROPSALARMSTAB
            break
        case ReportTabID.SCHEDULING:
            topic = DocTopic.RPTGRPTPROPSSCHEDULESETTINGSTAB
            break
        case ReportTabID.ACDCODES:
            topic = DocTopic.RPTGRPTPROPSACDCODESTAB
            break
        case ReportTabID.FINANCIAL:
            topic = DocTopic.RPTGRPTPROPSFINANCIALTAB
            break
        case ReportTabID.SETTINGS:
            topic = DocTopic.RPTGRPTPROPSSETTINGSTAB
            break
        case ReportTabID.PRINT:
            topic = DocTopic.RPTGRPTPROPSPRINTTAB
            break
        case ReportTabID.ADVANCED:
            topic = DocTopic.RPTGRPTPROPSADVANCEDTAB
            break
        case ReportTabID.DASHBOARD:
            topic = DocTopic.RPTGRPTPROPSDASHBOARDTAB
            break
        case ReportTabID.OTHER:
            topic = DocTopic.RPTGRPTPROPSOTHERTAB
            break
        default:
            topic = DocTopic.RPTGRPTPROPSRPTTAB
            break
    }
    return topic
}

export const ENITITY_STAT_TYPE_INTERVAL_ID: number = 1102
export const ENTITY_STAT_TYPE_DAYS_OF_WEEK_ID: number = 1110
export const ENTITY_STAT_TYPE_DEVICE_ID: number = 1550
export const ENTITY_STAT_TYPE_AGENT_ID: number = 1551
export const ENTITY_STAT_TYPE_DNIS_DIGIT: number = 1508

export const ENTITY_TYPE_DNIS: number = 110

export const ENTITY_STAT_FIXED_FIELDS: number[] = [
    ENITITY_STAT_TYPE_INTERVAL_ID,
    ENTITY_STAT_TYPE_DAYS_OF_WEEK_ID,
    ENTITY_STAT_TYPE_DEVICE_ID,
    ENTITY_STAT_TYPE_AGENT_ID,
    ENTITY_STAT_TYPE_DNIS_DIGIT
]

export const ENTITY_STAT_FIXED_ENTITIES: number[] = [
    ENTITY_STAT_TYPE_DEVICE_ID,
    ENTITY_STAT_TYPE_AGENT_ID,
    ENTITY_STAT_TYPE_DNIS_DIGIT
]

export const CSV_REPORT_SORTING_VALUE: string = 'S=1;'
